module.exports = __webpack_public_path__ + "static/media/tools-addnote2.c788101b.svg";